import styled from 'styled-components';

interface CardProps {
    color?: string;
    sm?: boolean;
    triangle?: boolean;
    border?: boolean;
    bColor?: string;
    md?: boolean;
    variant?: string;
}

export const Card = styled.div<CardProps>`
    padding: 18px;
    border-radius: 8px;
    position:relative;
    width: 100%;
    height: 100%;
    background-color:${props => props.color ? props.color : '#fff'};
    border: ${props => props.border ? `1.5px solid ${props.bColor ? props.bColor : '#eef0f2'}` : '0 none'};

    ${props => props.md && `
        display:flex;
        align-items:center;
        justify-content:center;
        gap:10px;
        flex-direction:column;
    `}
`

interface ButtonProps {
    bkcolor?: string;
    color?: string;
    bdcolor?: string;
    sm?: boolean;
    hovercolor?: string;
    hoverbk?: string;
}

export const MyButton = styled.button<ButtonProps>`
    display: flex;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    color: ${props => props.color ? props.color : '#fff'};
    background:${props => props.bkcolor ? props.bkcolor : '#1db461'};
    border:${props => props.bdcolor ? `1.5px solid ${props.bdcolor}` : '0 none'};
    font-weight: 600;
    font-size: 16px;
    border-radius: 50px;
    cursor: pointer;
    transition: opacity .3s;
    padding: ${props => props.sm ? `10px 15px` : '12px 27px'};

    :hover{
        ${props => props.hovercolor || props.hoverbk ? `
            ${props.hovercolor && `color:${props.hovercolor};`}
            ${props.hoverbk && `background:${props.hoverbk};`}
        ` : `
            opacity: .85;
        `}
    }
`